// client/src/hooks/usePlataformaGoogleNegocio.js
// Client ID/Secret do app OAuth do Google Meu Negócio da plataforma —
// configurado pela matriz, consumido por toda Conta que conectar. Espelha
// usePlataformaNotaFiscal.js (mesma ideia de config única).
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';
import useAlert from './useAlert';

const errMsg = (err, fallback) => err.response?.data?.error || err.response?.data?.message || fallback;

export const usePlataformaGoogleNegocioConfig = () => useQuery({
    queryKey: ['plataforma-google-negocio', 'config'],
    queryFn: () => apiClient.get('/plataforma-google-negocio/config').then((r) => r.data.data),
});

export const useSalvarPlataformaGoogleNegocioConfig = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();
    return useMutation({
        mutationFn: (payload) => apiClient.put('/plataforma-google-negocio/config', payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['plataforma-google-negocio', 'config'] });
            setAlert('Configuração do Google Meu Negócio salva com sucesso.', 'success');
        },
        onError: (err) => setAlert(errMsg(err, 'Erro ao salvar configuração do Google Meu Negócio.'), 'danger'),
    });
};
